<ng-container *ngIf="isEditor">
  <div
    *ngIf="!(productId$ | async)"
    class="ds-info mb-3"
    i18n="@@orderbump.product.not_selected"
  >
    Es wurde noch kein Produkt ausgewählt!
  </div>
  <div
    *ngIf="(productId$ | async) && !(productMatch$ | async)"
    class="ds-info mb-3"
    i18n="@@orderbump.product.no_match_reload"
  >
    Bitte fügen Sie Produkt {{ productId$ | async }} bei Produkt
    {{ mainProductId$ | async }} als Addon hinzu. Dann speichern und laden Sie
    Ihr Bestellformular neu.
  </div>
  <div
    *ngIf="(contentValidWithInput$ | async) === false"
    class="ds-info mb-3"
    i18n="@@orderbump.need_INPUT_element"
  >
    Bitte fügen Sie eine Eingabe in das Orderbump hinzu.
  </div>
  <div
    *ngIf="productIsMainProduct$ | async"
    class="ds-info mb-3"
    i18n="@@orderbump.product.is_main_product"
  >
    Bitte wählen Sie nicht das Hauptprodukt als Produkt für das Orderbump.
  </div>
</ng-container>
